<template>
  <el-dialog
    title="薪资报表详情"
    :visible="salaryDialogType == 'detail'"
    :close-on-click-modal="false"
    :before-close="closeDialog"
    @open="initDialog"
    width="80%"
  >
    <div>
      <el-table :data="salaryList" tooltip-effect="dark" stripe>
        <el-table-column prop="staff_real_name" label="姓名"> </el-table-column>
        <el-table-column prop="company_name" label="所属公司">
        </el-table-column>
        <el-table-column prop="bank_name" label="银行名称"> </el-table-column>
        <el-table-column prop="bankcard_num" label="银行卡号">
        </el-table-column>
        <el-table-column prop="bankcard_info" label="支行"> </el-table-column>
        <el-table-column prop="contract_salary" label="薪资">
        </el-table-column>
        <el-table-column prop="bonus" label="奖金"> </el-table-column>
        <el-table-column prop="allowance" label="补贴"> </el-table-column>
        <el-table-column prop="social_insurance" label="社保缴纳">
        </el-table-column>
        <el-table-column prop="housing_fund" label="公积金">
        </el-table-column>
        <el-table-column prop="income_tax" label="个人所得税">
        </el-table-column>
        <el-table-column prop="deduct_for_leave" label="请假扣除">
        </el-table-column>
        <el-table-column prop="deduct_for_late" label="迟到扣除">
        </el-table-column>
        <el-table-column prop="extra" label="额外调整"> </el-table-column>
        <el-table-column prop="final_salary" label="实发薪资">
        </el-table-column>
        <el-table-column prop="part_a_salary" label="基本工资">
        </el-table-column>
        <el-table-column prop="part_b_salary" label="绩效工资">
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import { managerSalaryReportDetail } from '@/api/manager'
export default {
  data() {
    return {
      isLoading: false,
      salaryList: [],
      salaryReportDetails: {},
    }
  },
  props: ['salaryDialogType', 'reportId'],
  methods: {
    // 关闭模态框
    closeDialog() {
      this.salaryReportDetails = {}
      this.$emit('update:salaryDialogType', false)
    },
    // 初始化模态框
    async initDialog() {
      let { code, result } = await managerSalaryReportDetail({
        report_id: this.reportId,
      })
      if (code == this.CONFIG.CODE_SUCCESS) {
        this.salaryList = result
      }
    },
  },
}
</script>

<style lang="less" scoped>
.table-page {
  margin-top: 15px;
  text-align: center;
}
/deep/ .el-table {
  font-size: 12px !important;
}
</style>
